import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { ref: "listingCalendar" }
const _hoisted_2 = ["action"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  name: "wersja",
  value: "kroki",
  type: "hidden"
}, null, -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  name: "flow",
  value: "autobooking",
  type: "hidden"
}, null, -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ListingCalendarSkeleton = _resolveComponent("ListingCalendarSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!_ctx.calendarArray.length)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          ref: "listingCalendarForm",
          method: "get",
          action: _ctx.redirect
        }, [
          _createVNode(_component_Calendar, {
            "clicked-slots": _ctx.slotsSelected,
            days: _ctx.calendarArray,
            "compressed-view": "",
            class: "mb-15",
            onOnSlotsChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSlotChange($event)))
          }, null, 8, ["clicked-slots", "days"]),
          _hoisted_3,
          _createElementVNode("input", {
            name: "data[AutobookingEvent][slot]",
            value: _ctx.slotSelected,
            type: "hidden"
          }, null, 8, _hoisted_4),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][serviceId]",
            value: _ctx.dataServiceUuid,
            type: "hidden"
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _createElementVNode("input", {
            name: "source",
            value: _ctx.dataPricing ? 'pricing' : 'listing',
            type: "hidden"
          }, null, 8, _hoisted_7),
          _createElementVNode("input", {
            name: "showOtherForm",
            value: _ctx.dataShowOtherForm,
            type: "hidden"
          }, null, 8, _hoisted_8),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][lng]",
            value: _ctx.mechanicMeta?.lng,
            type: "hidden"
          }, null, 8, _hoisted_9),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][lat]",
            value: _ctx.mechanicMeta?.lat,
            type: "hidden"
          }, null, 8, _hoisted_10),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][address]",
            value: _ctx.mechanicMeta?.address,
            type: "hidden"
          }, null, 8, _hoisted_11),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][zilo_id]",
            value: _ctx.mechanicMeta?.zilo_id,
            type: "hidden"
          }, null, 8, _hoisted_12),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][mechanic_id]",
            value: _ctx.dataMechanicId,
            type: "hidden"
          }, null, 8, _hoisted_13),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][category_id]",
            value: _ctx.dataServiceCategoryUuid,
            type: "hidden"
          }, null, 8, _hoisted_14),
          _createElementVNode("input", {
            name: "data[AutobookingEvent][repairDescription]",
            value: _ctx.serviceMeta?.name,
            type: "hidden"
          }, null, 8, _hoisted_15)
        ], 8, _hoisted_2))
      : (!!_ctx.slots)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_16, " Brak wolnych terminów "))
        : (_openBlock(), _createBlock(_component_ListingCalendarSkeleton, { key: 2 }))
  ], 512))
}